// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    about_item: 'Подробнее о {0}',
    add: 'Добавить',
    AddMoreSpace: 'Добавить больше',
    all_projects_label: 'Все проекты',
    approval_all_label: 'Параллельное утверждение',
    approval_all_tooltip: 'Все назначенные утверждающие должны утвердить, чтобы расходы были одобрены.',
    approval_one_label: 'Первичное утверждение',
    approval_one_tooltip: 'Утверждено любым одним пользователем. Дополнительные утверждения не требуются.',
    approve_label: 'Согласовать',
    archive_action_text: 'Заархивировать',
    archive_date_label: 'Дата архивирования',
    archived_by_label: 'Заархивировано',
    Attach: 'Прикрепить файл',
    attach_file_image: 'Прикрепить файл или изображение',
    automation_purchase_notes: 'Пожалуйста, свяжитесь с нами по адресу <a href=\'mailto:billing@birdviewpsa.com\'>billing@birdviewpsa.com</a> для выбора другого способа оплаты, помимо дебетовой карты.',
    automation_trial_description_end: ' и увидьте автоматизацию Birdview в действии!',
    automation_trial_description_middle: '30-дневного бесплатного пробного периода',
    automation_trial_description_start: 'Начните с ',
    automation_trial_expired: 'Ваша пробная версия истекла.',
    automation_trial_expired_notes: 'Пожалуйста, свяжитесь с нами по адресу <a href=\'mailto:support@birdviewpsa.com\'>support@birdviewpsa.com</a>, если вам нужна помощь.',
    btn_reload: 'Перезагрузить',
    buy_subscription: 'Купить подписку',
    Cancel: 'Отменить',
    change: 'Изменить',
    checkbox_list_text: 'Список выбора нескольких значений',
    Close: 'Закрыть',
    completeActivityConfirm: 'Вы указали, что задача завершена на 100%. Хотите ли вы изменить статус задачи на \'выполнено\'? Нажмите \'OK\' для изменения статуса, иначе нажмите \'Отмена\'.',
    completeActivityTitle: 'Завершить эту задачу?',
    completeProjectConfirm: 'Вы выставили прогресс проекта в 100%. Хотите ли вы его закрыть? Нажмите \'OK\' чтобы изменить статус.',
    completeProjectTitle: 'Завершить этот преокт?',
    confirmCompleteActivityParents: 'После завершения этой подзадачи не останется открытых задач в родительской задаче. Хотите ли Вы пометить родительскую задачу как выполненную? Обратите внимание, что если больше нет открытых задач в проекте, он также будет помечен как выполненный.',
    confirmCompleteActivityParentsTitle: 'Пометить {0} как выполненную задачу?',
    contact_us: 'Связаться с нами',
    continue: 'Продолжить',
    copied_label: 'Скопировано',
    copy_link_feedback: 'Ссылка скопирована.',
    copying_label: 'Копирование',
    copyLink: 'Скопировать ссылку',
    custom_field_label: 'Дополнительное поле',
    custom_form_label: 'Настраиваемая форма',
    date_text: 'Дата',
    DayAbbreviation: 'д',
    DayPluralFormat: '7#день#дня#дней',
    DayPluralFormatTemplate: '7#{0} день#{0} дня#{0} дней',
    Delete: 'Удалить',
    delete_confirmation: 'Данное действие невозможно отменить.',
    delete_permanently_text: 'Удалить навсегда',
    description_information: 'для {0}',
    disabled: 'Неактивный',
    disabledUserText: '(неактивный)',
    Download: 'Скачать',
    dropdown_text: 'Выпадающий список',
    Duplicate: 'Копировать',
    Edit: 'Отредактировать',
    ElapsedTime_Ago: '{0} назад',
    enabled: 'Активный',
    Entity_Category: 'Категория',
    Entity_Customer: 'Заказчик',
    Entity_Invoice: 'Счет',
    Entity_Issue: 'Проблема',
    Entity_JobRole: 'Должность',
    Entity_Portfolio: 'Портфолио',
    Entity_Priority: 'Приоритет',
    Entity_Project: 'Проект',
    Entity_ProjectStatus: 'Статус',
    Entity_Request: 'Запрос',
    Entity_Task: 'Задача',
    Entity_TaskStatus: 'Статус',
    Entity_User: 'Пользователь',
    Error_CantFindObjectTemplate: 'Операция не может быть выполнена по следующей причине: объект (тип: {entityName}, ключ: {objectKey}) не найден в базе данных. Это может быть связано с удалением элемента, или отсутствием прав на просмотр данного элемента. Проконсультируйтесь с вашим администратором {brandName} для уточнения возможной причины.',
    error_notFullyCompleted: 'Был удален используемый объект или пользователь, либо было отказано в правах доступа со стороны другого пользователя.',
    ErrorFileSizeLimit: 'Загрузка файла {0} была отменена, так как pазмер загружаемого файла не должен превышать ∼ {1} ГБ.',
    ErrorUploadExceededText: 'Загрузка файла {0} была отменена, так как закончился лимит доступного места.',
    ErrorUploadText: 'При загрузке файла {0} возникла непредвиденная ошибка, и файл загрузить не удалось. Повторите процесс загрузки файла.',
    ErrorUploadTitle: 'Ошибка загрузки файла.',
    ErrorVirusText: 'Добавленный вами файл содержал вирус, рекомендуем удалить его и проверить компьютер.',
    ErrorVirusTitle: 'Вирусный файл',
    exported: 'Экспортировано',
    exporting: 'Экспортирование',
    failed: 'Неудачно',
    help: 'Помощь',
    HourAbbreviation: 'ч',
    HourPluralFormat: '7#час#часа#часов',
    HourPluralFormatTemplate: '7#{0} час#{0} часа#{0} часов',
    HyperLinkTooltip: 'CTRL+Щелчок для перехода по ссылке',
    items_selected_plural: '7#Выбран {0} элемент#Выбрано {0} элемента#Выбрано {0} элементов',
    MinuteAbbreviation: 'м',
    MinutePluralFormat: '7#{0} мин#{0} мин#{0} мин',
    more_counter_text: 'и ещё {0}',
    next: 'Продолжить',
    no_items_selected: 'Ничего не выбрано',
    None_Text: 'Нет',
    Not_set: 'Не задано',
    one_after_another_label: 'Последовательное утверждение',
    one_after_another_tooltip: 'Согласующие должны утверждать в определённом порядке, один за другим.',
    open_details_new_tab: 'Открыть детали в новой вкладке',
    open_in_new_tab: 'Открыть в новой вкладке',
    OpeningWindow: 'Открытие...',
    OpenOriginal: 'Открыть оригинал',
    OperationError_Title: 'Операция не может быть выполнена',
    paragraph_text: 'Параграф',
    parentActivity: 'родительскую задачу',
    PerDay: 'в день',
    PerWeek: 'в неделю',
    project_custom_fields_label: 'Поля для проекта',
    reject_label: 'Отклонить',
    Remove: 'Удалить',
    request_has_been_sent_successfully: 'Запрос был успешно отправлен. Команда поддержки свяжется с вами.',
    Request_Trial: 'Попробовать сейчас',
    Reset: 'Сбросить',
    Save: 'Сохранить',
    saved: 'Сохранено',
    saving: 'Сохранение',
    Search: 'Поиск',
    select_placeholder: 'Выберите...',
    selection_mode_text: 'Режим выбора',
    sending: 'Отправка',
    setCompleted: 'Пометить как выполненную',
    show_less_label: 'Показать меньше',
    show_more_label: 'Показать больше',
    space_exceeded_description: 'Недостаточно свободного места для хранения файлов.',
    space_exceeded_title: 'Хранилище заполнено',
    submit: 'Потвердить',
    subscribe_trouble_description: 'Пожалуйста, свяжитесь с нами по адресу <a href=\'mailto:success@birdviewpsa.com\'>success@birdviewpsa.com</a>, чтобы уточнить статус вашей подписки.',
    summary: 'Статистика',
    time_input_placeholder: 'Введите время: 2ч 30м',
    timer_text: '7#{0} секунда#{0} секунды#{0} секунд',
    title_notFullyCompleted: 'Не удалось выполнить действие целиком или частично',
    title_reload: 'Пожалуйста, перезагрузите страницу',
    total: 'Итого',
    turn_off: 'Отключить',
    type: 'Тип',
    Type_for_search: 'Введите текст для поиска',
    Type_for_search_or_add: 'Введите текст для поиска или добавления',
    Type_for_search_or_create: 'Введите текст для поиска или создания',
    unarchive_action_text: 'Разархивировать',
    undo_label: 'Отменить',
    undoing: 'Отмена изменения',
    undone: 'Отменено изменение',
    upload: 'Загрузить',
    WebPushNotificationPanelLink: 'включение уведомлений',
    WebPushNotificationPanelText: '{brandName} необходимо ваше разрешение на ',
    you_user_text: 'вы',
};
